<app-basic-bar-chart class="hide-check" [config]="ChartConfig.ControlStructureRainfall"></app-basic-bar-chart>
<app-basic-bar-chart class="hide-check" [config]="ChartConfig.WaterLevels"></app-basic-bar-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.IslandBlockRoadTotalNutrients"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.IslandBlockRoadWaterChemistry"
></app-basic-cartesian-chart>
<app-basic-bar-chart class="hide-check" [config]="ChartConfig.IslandBlockRoadDOM"></app-basic-bar-chart>
